import axios from "axios";

import { isLocalStorageAvailable } from "../../isLocalStorageAvailable";
import { DISCORD_AUTH_LINK } from "../../../utils/constants";

const BASE_URL = 'https://discord.com/api/users/@me';

const client = axios.create({
  baseURL: BASE_URL,
});

client.interceptors.request.use(async config => {
  const tokenData = isLocalStorageAvailable() ? JSON.parse(localStorage.getItem('__ds__auth')) : window.__ds__auth;

  return {
    ...config,
    headers: {
      Authorization: `${tokenData?.token_type} ${tokenData?.access_token}`
    }
  };
}, Promise.reject);

client.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      if (isLocalStorageAvailable()) {
        localStorage.setItem('__ds__auth', null)
      } else {
        window.__ds__auth = null;
      }

      window.location = DISCORD_AUTH_LINK;
    }

    return Promise.reject(error);
  }
);

export default client;
